import { render, staticRenderFns } from "./pi_thickness.vue?vue&type=template&id=15fbf59d&scoped=true"
import script from "./pi_thickness.vue?vue&type=script&lang=js"
export * from "./pi_thickness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbf59d",
  null
  
)

export default component.exports